import React from "react";
import { useFetcher } from "react-router-dom";
import { useFetcherBusy } from "~/hooks/useRouteActivity";
import { convertCurrencyToLowest, INTENTS } from "~/utils";
import { useGetEntityList } from "~/hooks";
import { Form, message } from "antd";
import * as APITypes from "~/API";
import { getEntityListOptions } from "~/services/browser";
import { useTranslation } from "react-i18next";

export const useNewServiceRequestButton = (
  ownerID: string,
  ownerType: APITypes.OwnerType,
  initialValues: any,
  canCreateRequest: boolean
) => {
  const { t } = useTranslation();
  const [formInstance] = Form.useForm();
  const [showCreateDrawer, setShowCreateDrawer] = React.useState(false);
  const [showSubmitConfirm, setShowSubmitConfirm] = React.useState(false);
  const [entityType, set_EntityType] = React.useState<APITypes.EntityType>(
    initialValues?.entityType || "property"
  );
  const fetcher = useFetcher();
  const isLoading = useFetcherBusy(fetcher);
  const entityList = useGetEntityList({
    entityType: entityType,
    ownerID,
    ownerType,
  });
  const entityListOptions: { value: string; text: string }[] =
    getEntityListOptions(entityList.data);
  const toggleCreateDrawer = () => {
    // formInstance.resetFields();
    setShowCreateDrawer(!showCreateDrawer);
  };
  const toggleSubmitConfirm = () => setShowSubmitConfirm(!showSubmitConfirm);

  const handle_EntityTypeOnChange = (value: any) => {
    set_EntityType(value as APITypes.EntityType);
    formInstance.setFieldValue("entityID", undefined);
  };
  const handleCreateRequestSubmit = (formValues: any) => {
    // Check permission before submitting
    if (!canCreateRequest) {
      message.error(t("No_Permission_To_Create_Service_Requests"));
      return;
    }

    formValues.estimatedCost = convertCurrencyToLowest(
      formValues.estimatedCost
    );
    fetcher.submit(
      {
        body: JSON.stringify(formValues),
        intent: INTENTS._add_service_request,
      },
      { method: "post" }
    );
    toggleCreateDrawer();
  };
  return {
    formInstance,
    entityType,
    entityListOptions,
    showCreateDrawer,
    showSubmitConfirm,
    isLoading,
    isSubmitting: fetcher.state !== "idle",
    is_EntityTypeLoading: entityList.isLoading || entityList.isFetching,
    toggleCreateDrawer,
    toggleSubmitConfirm,
    handle_EntityTypeOnChange,
    handleCreateRequestSubmit,
  };
};
